import { useQuery } from '@tanstack/react-query';
import adminInventoryService from '../../services/adminInventoryService';

export const useSupplierSearch = (query) => {
  return useQuery({
    queryKey: ['admin-inventory-suppliers-search', query],
    queryFn: () => adminInventoryService.searchSuppliers(query),
    enabled: !!query?.trim(),
    staleTime: 1000 * 60 * 5,
  });
};
